import classNames from "classnames";
import { findIndex } from "lodash";
import Toggle from "PFComponents/toggle/toggle";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import css from "./fields.less";

const DragItem = ({ label, checked, onChange }) => (
  <div className={css.dragItem}>
    <span className={css.dragHandle}>⸬</span>
    <Toggle reversed compact description={label} checked={checked} onChange={() => onChange(!checked)} />
  </div>
);

DragItem.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

const Fields = ({ fields, onChange, customTypes }) => {
  const [items, setItems] = useState([]);
  const fieldsRef = useRef();

  const handleToggle = (field, value) => {
    const newItems = [...items];
    const item = newItems.find((item) => item.id === field);
    if (item) {
      item.checked = value;
    }
    setItems(newItems);
    onChange(newItems.filter((item) => item.checked).map((item) => item.id));
  };

  useEffect(() => {
    const allItems = [
      { id: "summary", label: "Summary", checked: false },
      { id: "experience", label: "Experience", checked: false }
    ];
    customTypes.map(({ name, display_as }) => allItems.push({ id: name, label: display_as, checked: false }));

    const reversedFields = [...fields].reverse();

    reversedFields.map((field) => {
      const itemIndex = findIndex(allItems, (item) => item.id === field);
      if (itemIndex >= 0) {
        const item = allItems[itemIndex];
        item.checked = true;
        allItems.splice(itemIndex, 1);
        allItems.unshift(item);
      }
    });

    setItems(allItems);
  }, []);

  return (
    <div>
      <DragDropContext
        onDragEnd={(result) => {
          if (!result.destination) {
            return;
          }

          const newItems = [...items];
          const [item] = newItems.splice(result.source.index, 1);
          newItems.splice(result.destination.index, 0, item);
          setItems(newItems);
          onChange(newItems.filter((item) => item.checked).map((item) => item.id));
        }}
      >
        <div className={css.fieldsBox} ref={fieldsRef}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <>
                {provided.placeholder}

                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {items.map((item, index) => (
                    <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                      {(provided, snapshot) => {
                        const style = { ...provided.draggableProps.style };

                        return (
                          <div
                            className={classNames(css.draggableInner, { [css.dragged]: snapshot.isDragging })}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={style}
                          >
                            <DragItem
                              label={item.label}
                              checked={item.checked}
                              onChange={(checked) => handleToggle(item.id, checked)}
                            />
                          </div>
                        );
                      }}
                    </Draggable>
                  ))}
                </div>
              </>
            )}
          </Droppable>
        </div>
      </DragDropContext>
    </div>
  );
};

Fields.propTypes = {
  customTypes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      display_as: PropTypes.string
    })
  ).isRequired,
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired
};

export default Fields;
